<template>
  <b-container class="page-container" fluid>
    <NextLevelAromaEmpressCheckout />
  </b-container>
</template>
<style>
</style>

<script>
import NextLevelAromaEmpressCheckout from "@/components/checkout/nextlevelaromaempress/NextLevelAromaEmpressCheckout.vue";

export default {
  title: "Next Level Aroma Empress",
  name: "NextLevelAromaEmpress",
  mounted: function() {
    let optimize = document.createElement("script");
    optimize.setAttribute("src",  "https://www.googleoptimize.com/optimize.js?id=OPT-WDWCDZ9");
    document.head.appendChild(optimize);
  },
  components: {
    NextLevelAromaEmpressCheckout,
  },
};
</script>
